<template>
  <div class="col-start-1 col-span-6 flex justify-center">
    <ul>
      <li
        v-for="({ name, responsibility }, i) in credits"
        :key="i"
        class="text-3-mob lg:text-3-desk"
      >
        <span class="italic">{{ responsibility }}: </span>
        <span class="small-caps">{{ name.toLowerCase() }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ContentCredits",

  props: {
    credits: {
      type: Array,
      default: () => []
    }
  }
};
</script>
